import Contact from '../components/Contact.vue'
import { bootstrapPage } from '../bootstrapPage'

bootstrapPage(Contact)
